<template>
    <div class="animated fadeIn h-100 admin-container">
        <div class="page-content">
            <b-row>
                <b-col class="text-right">
                    <b-button variant="outline-primary" @click="openCreateModal">
                        <i class="fa fa-plus-circle mr-2"></i>
                        <span class="text-uppercase">Thêm cấu hình</span>
                    </b-button>
                </b-col>
            </b-row>
            <b-table class="mt-2" striped hover :items="listConfig" :fields="fields" show-empty :filter="searchKeyword"
                :filter-included-fields="['key']">
                <template v-slot:cell(index)="data">{{ data.index + 1 }}</template>
                <template v-slot:cell(actions)="row">
                    <b-button variant="primary" class="mr-1 min-width-none" @click="openEditModal(row.item)"
                        v-b-tooltip.hover :title="$t('common.edit')">
                        <i class="fa fa-pencil"></i>
                    </b-button>
                    <b-button variant="danger" @click="confirmDelete(row.item)" v-b-tooltip.hover class="min-width-none"
                        :title="$t('common.delete')">
                        <i class="fa fa-trash"></i>
                    </b-button>
                </template>
            </b-table>
        </div>

        <b-modal ref="createOrUpdateModal" :title="`${form.id ? $t('common.update') : $t('common.create')}`"
            ok-title="Lưu" @ok="handleCreateOk" :cancel-title="$t('common.cancel')">
            <b-form-group label="Tên">
                <b-form-input v-model="form.key" v-validate="'required'" name="key" data-vv-as="Tên"></b-form-input>
                <div v-show="errors.has('key')" class="validation-message text-danger">
                    {{ errors.first('key') }}
                </div>
            </b-form-group>
            <b-form-group label="Nội dung">
                <b-form-textarea v-model="form.value" v-validate="'required'" name="value" rows="10"
                    data-vv-as="Nội dung"></b-form-textarea>
                <div v-show="errors.has('value')" class="validation-message text-danger">
                    {{ errors.first('value') }}
                </div>
            </b-form-group>
        </b-modal>

        <b-modal ref="restoreModal" title="Chọn file sao lưu" ok-title="Phục hồi" @ok="handleRestoreOk"
            :cancel-title="$t('common.cancel')">
            <b-form-group label="Chọn file">
                <b-form-file v-model="file" name="file" required placeholder="Chọn file sao lưu"
                    accept=".zip"></b-form-file>
            </b-form-group>
        </b-modal>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { saveAs } from 'file-saver';

export default {
    async mounted() {
        await this.$nextTick();
        this.listConfig = await this.getList();
    },
    data: function () {
        return {
            fields: [
                { tdClass: 'align-middle', key: 'index', label: '#' },
                {
                    tdClass: 'align-middle',
                    thClass: 'fixed-actions-col',
                    key: 'key',
                    label: 'Tên'
                },
                {
                    tdClass: 'align-middle',
                    key: 'value',
                    label: 'Nội dung'
                },
                {
                    thClass: 'fixed-actions-col',
                    key: 'actions',
                    label: this.$i18n.t('common.actions'),
                    thStyle: { width: '100px' }
                }
            ],
            form: {},
            searchKeyword: null,
            file: null,
            listConfig: []
        };
    },
    methods: {
        ...mapActions({
            getList: 'config/getList',
            create: 'config/create',
            update: 'config/update',
            delete: 'config/delete',
            backup: 'config/backup',
            restore: 'config/restore',
            createAuditByUser: 'user/createAuditByUser'
        }),
        handleCreateOk(modal) {
            modal.preventDefault();
            this.$validator.validateAll().then(async result => {
                if (result) {
                    if (this.form.id) {
                        await this.update(this.form);
                    } else {
                        await this.create(this.form);
                    }
                    this.$toaster.success('Thành công');
                    this.createAuditByUser({ content: 'Cập nhật cấu hình' });
                    this.$refs.createOrUpdateModal.hide();
                    this.listConfig = await this.getList();
                }
            });
        },
        async onDelete(modal) {
            modal.preventDefault();
        },
        async openEditModal(item) {
            this.resetForm();
            this.form = { ...item };
            this.form.password = null;
            this.$refs.createOrUpdateModal.show();
        },
        openCreateModal() {
            this.resetForm();
            this.$refs.createOrUpdateModal.show();
        },
        resetForm() {
            this.form = {};
        },
        async backupSystem() {
            const data = await this.backup();
            saveAs(data, `Trung tâm Quy hoạch và Điều tra Tài nguyên nước quốc gia-${new Date().toTimeString()}.zip`);
            this.$toaster.success('Thành công');
            this.createAuditByUser({ content: 'Sao lưu cấu hình' });
        },
        openRestoreModal() {
            this.file = null;
            this.$refs.restoreModal.show();
        },
        handleRestoreOk(modal) {
            modal.preventDefault();
            this.$validator.validateAll().then(async result => {
                if (result) {
                    const formData = new FormData();
                    formData.append('file', this.file);
                    await this.restore({ formData });
                    this.$toaster.success(
                        'Thành công. Vui lòng khởi động lại phần mềm để áp dụng thay đổi.'
                    );
                    this.createAuditByUser({ content: 'Phục hồi cấu hình' });
                    this.$refs.restoreModal.hide();
                }
            });
        },
        async confirmDelete(item) {
            const result = await this.$bvModal.msgBoxConfirm('Bạn có chắc chắn muốn xoá không?', {
                title: 'Xác nhận',
                okVariant: 'danger',
                okTitle: 'Có',
                cancelTitle: 'Không'
            });
            if (result) {
                await this.delete({ id: item.key });
                this.listConfig = await this.getList();
                this.$toaster.success('Xoá thành công');
                this.createAuditByUser({ content: 'Xoá cấu hình' });
            }
        }
    }
};
</script>
